// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"d0c17e42","644":"52e524ef","956":"5d197003"}[chunkId] + ".chunk.js";
};